import React from 'react';

function Download() {
    return <div></div>;
}

export default Download;
